module.exports = __webpack_public_path__ + "static/media/unionpay.e80816ad.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/unionpay.svg
// module id = 495
// module chunks = 0